const React = require('react');
const EmojiPicker = require('components/EmojiPicker');

module.exports = function FormEmojiField(props) {

    const {
        field = {},
        label = field.label,
        inputProps,
        onBlur,
        onChange,
        onFocus,
        setValue,
        value = ''
    } = props;

    return <EmojiPicker
        inputProps={inputProps}
        label={label}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value || ''}
        onChange={(nextValue) => {

            if (typeof setValue === 'function') {
                setValue(nextValue);
            }

            if (typeof onChange === 'function') {
                onChange(nextValue);
            }
        }}
    />;
};
